import { Button, styled } from "@mui/material";

export const IconButtonRoot = styled(Button)(() => ({ height: 16, width: 16, fontSize: "11px", minWidth: "16px" }));
